import React, { useState } from "react";
import {
  Button,
  Card,
  Container,
  Form,
  Row,
  Stack,
  ThemeProvider,
} from "react-bootstrap";
import logo from "../Assets/Logo/NYC-Logo.png";
import { FaArrowLeft } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { LoadingScreen } from "../LoadingScreen";
import axios from 'axios';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../msalConfig";

const SalesPersonAuthentication = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const { instance } = useMsal();        // <-- ensures 'instance' exists
  const [password, setPassword] = useState("");
  const inputStyle = { borderRadius: "0", padding: "0.6rem" };
  const buttonStyle = {
    borderRadius: "0",
    padding: "0.6rem",
    marginBottom: "8px",
  };

  const handleChangeEmail = (value) => {
    setEmail(value);
  };

  const handleBackClick = () => {
    navigate("/"); // Navigate to the home screen
  };

  const handleChangePassword = (value) => {
    setPassword(value);
  };

  const generateAndStoreToken = async (email) => {
    try {
      // Call the API to generate a 30-minute token
      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/auth/verify/generate-120min-token`, { email });

      // Check if the response is successful and contains the token
      if (response.data.token) {
        // Store the token in localStorage
        localStorage.setItem('120MinToken', response.data.token);
        console.log('Token stored successfully:', response.data.token);
      } else {
        console.error('No token received:', response.data.message);
      }
    } catch (error) {
      console.error('Error generating token:', error.response ? error.response.data : error.message);
    }
  };

  const handleEmailSubmit = async (e) => {
    setLoading(true)
    try {
      e.preventDefault();
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/auth/salespersonAuth/validate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email,
            password: password,
          }),
        }
      );
      console.log("Response Status", response.status)
      // try {
      //   const loginResponse = await instance.loginPopup(loginRequest);
      //   // Acquire token for Dynamics scope (silent first, popup fallback)
      //   const tokenResponse = await instance.acquireTokenSilent({
      //     scopes: [process.env.REACT_APP_AUTHENTICATE],
      //     account: loginResponse.account,
      //   }).catch(async (err) => {
      //     return instance.acquireTokenPopup({
      //       scopes: [process.env.REACT_APP_AUTHENTICATE],
      //     });
      //   });

        if (response.ok) {
          // console.log("tokenResponse", tokenResponse);
          // console.log("Access token", tokenResponse.accessToken);
          await generateAndStoreToken(email)
          toast.success("Login successful. Please wait while we redirect you to the next screen");
          localStorage.setItem("validWithOTP", true);
          localStorage.setItem("callApiData", true)
          localStorage.setItem("validSalesPerson", true);
          localStorage.setItem("validNewCustomer", true);
          localStorage.setItem('scannedQR', false);
          localStorage.setItem("NewUserEmail", email);
          localStorage.setItem("newUserValidation", false)
          // localStorage.setItem('120MinToken', tokenResponse.accessToken);
          setTimeout(() => {
            navigate("/home/inventory");
            window.location.reload();
            setLoading(false)
          }, 3000);
        }
        else {
        toast.error("Invalid credentials or user does not exist.");
        setLoading(false);
      }
      } catch (err) {
        console.error("Login error", err);
        toast.error("Error in Login. Please contact Admin.");
      }
    //   if (response.ok) {
    //     await generateAndStoreToken(email)
    //     toast.success("Login successful. Please wait while we redirect you to the next screen");
    //     localStorage.setItem("validWithOTP", true);
    //     localStorage.setItem("callApiData", true)
    //     localStorage.setItem("validSalesPerson", true);
    //     localStorage.setItem("validNewCustomer", true);
    //     localStorage.setItem('scannedQR', false);
    //     localStorage.setItem("NewUserEmail", email);
    //     localStorage.setItem("newUserValidation", false)
    //     setTimeout(() => {
    //       navigate("/home/inventory");
    //       window.location.reload();
    //       setLoading(false)
    //     }, 3000);
    //   } else {
    //     toast.error("Invalid credentials or user does not exist.");
    //     setLoading(false)
    //   }
    // } catch (error) {
    //   toast.info("Please try again.");
    //   console.error("Fetch error:", error);
    //   setLoading(false)
    // }
  };

  //   const handleEmailSubmit = async (e) => {
  //     e.preventDefault();
  //     setLoading(true);
  //     try {
  //         // Use the /check-user endpoint instead of /validate
  //         const response = await fetch(
  //             `${process.env.REACT_APP_SERVER_URL}/api/auth/salespersonAuth/check-user`,
  //             {
  //                 method: "POST",
  //                 headers: {
  //                     "Content-Type": "application/json",
  //                 },
  //                 body: JSON.stringify({
  //                     email: email
  //                 }),
  //             }
  //         );

  //         const data = await response.json();

  //         // Check if result is true, then call send-otp API
  //         if (data.result === true) {
  //             // Call send-otp endpoint
  //             const otpResponse = await fetch(
  //                 `${process.env.REACT_APP_SERVER_URL}/api/auth/verify/send-otp`,
  //                 {
  //                     method: "POST",
  //                     headers: {
  //                         "Content-Type": "application/json",
  //                     },
  //                     body: JSON.stringify({ email }),
  //                 }
  //             );

  //             const otpData = await otpResponse.json();

  //             if (otpResponse.ok) {
  //                 // Store email and OTP token in localStorage for OTP verification step
  //                 localStorage.setItem("EmailResponse", JSON.stringify({ email, token: otpData.token }));

  //                 toast.success("OTP sent successfully. Please check your email.");
  //             } else {
  //                 toast.error("Failed to send OTP. Please try again.");
  //             }
  //         } else {
  //             toast.error("Invalid credentials or user does not exist.");
  //         }
  //         setLoading(false);
  //     } catch (error) {
  //         toast.info("Please try again.");
  //         console.error("Fetch error:", error);
  //         setLoading(false);
  //     }
  // };


  // Example additional function to be called if result is true
  const additionalFunction = () => {
    console.log("Additional function called after successful validation.");
    // Additional logic here
  };


  return (
    <ThemeProvider
      breakpoints={["xxxl", "xxl", "xl", "lg", "md", "sm", "xs", "xxs"]}
      minBreakpoint="xxs"
    >
      {loading && <LoadingScreen />}
      <div className="bg-white min-h-screen  flex justify-center items-center">
        <div className="flex justify-center bg-white h-fit px-4">
          <div className="bg-white max-w-xl">
            <Container className="p-4">
              <Row className="">
                <Stack gap={2} className="">
                  <Card.Text
                    onClick={handleBackClick}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px",
                      // width: "20px",
                      // borderRadius: "50%",
                      // border: "1px solid red",
                      // transition: "background-color 0.3s",
                    }}
                  // onMouseEnter={(e) =>
                  //   (e.currentTarget.style.backgroundColor = "#e0e0e0")
                  // }
                  // onMouseLeave={(e) =>
                  //   (e.currentTarget.style.backgroundColor = "transparent")
                  // }
                  >
                    <FaArrowLeft style={{ marginRight: "8px" }} />
                  </Card.Text>
                  <Card className="d-flex justify-content-center align-items-center gap-3 border-0 mb-4">
                    <Card.Img
                      variant="top"
                      src={logo}
                      className="max-w-40"
                      style={{ objectFit: "contain" }}
                    />
                    <Card.Title className="text-2xl font-bold">
                      Log in
                    </Card.Title>
                    <Card.Text className="mx-4 text-center">
                      Welcome back! Please sign in to continue.
                    </Card.Text>
                  </Card>
                  <Form onSubmit={handleEmailSubmit}>
                    <Form.Group className="mb-3" controlId="formGroupEmail">
                      <Form.Label className="d-flex">
                        <p>Email address</p>
                        <p className="text-[#dc0a0b] ml-0.5">*</p>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        value={email}
                        onChange={(e) => handleChangeEmail(e.target.value)}
                        placeholder="Enter Email"
                        style={inputStyle}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formGroupPassword">
                      <Form.Label className="d-flex">
                        <p>Password</p>
                        <p className="text-[#dc0a0b] ml-0.5">*</p>
                      </Form.Label>
                      <Form.Control
                        type="password"
                        value={password}
                        onChange={(e) => handleChangePassword(e.target.value)}
                        placeholder="Enter Password"
                        style={inputStyle}
                        required
                      />
                    </Form.Group>
                    {/* <div className="mb-3">
                      <Form.Check
                        type="checkbox"
                        id="default-checkbox"
                        label="Keep me signed in"
                      />
                    </div> */}
                    <Row className="mx-auto">
                      <Button
                        variant="secondary"
                        style={buttonStyle}
                        type="submit"
                        className="me-3 text-lg bg-[#dc0a0b] border-[#dc0a0b] hover:bg-[#c40909] hover:border-[#c40909]"
                      >
                        Login
                      </Button>
                    </Row>
                  </Form>
                </Stack>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default SalesPersonAuthentication;
